import React, { Component, Suspense, lazy } from "react";
import { connect } from "react-redux";

import { Toaster } from "react-hot-toast";

import {
  searchUser,
  searchUserContent,
  friendSuggestion,
} from "../../services/stores/actions/compte";
import { getAllHashtags } from "../../services/stores/actions/hashtags";
import ReactLoading from "react-loading";
import ValidationPayment from "../Payment/ValidationPayment";
import defaultProfile from "../../assets/profil/utilisateur.png";
import CustomCard from "../Card/CustomCard";
import dataContent from "../../assets/data/content.json";
import CheckoutFormPaypal from "../Payment/CheckoutFormPaypal";
import Live from "../../views/Live/Live";

const CardHashtags = lazy(async () => await import("../Card/CardHashtags"));
const CardApplication = lazy(() => import("../Card/CardApplication"));
const CardPublicite = lazy(() => import("../Card/CardPublicite"));
const CardPourVous = lazy(() => import("../Card/CardPourVous"));
const StickyFooter = lazy(() => import("../Footer/StickyFooter/StickyFooter"));
const Home = lazy(() => import("../../views/home/home"));
const DetailsUserScreen = lazy(
  () => import("../../views/DetailsUser/DetailsUser")
);

const FormSignaler = lazy(() => import("../Signaler-Bloquer/Signaler"));
const InscriptionScreen = lazy(
  () => import("../../views/Inscription/InscriptionScreen")
);
const Login = lazy(() => import("../Login/Login"));
const FormBloquer = lazy(() => import("../Signaler-Bloquer/Bloquer"));
const FormBloquerInDiscussion = lazy(
  () => import("../Signaler-Bloquer/BloquerInDiscussion")
);

const MotDePasseOublier = lazy(
  () => import("../MotDePasseOublier/MotDePasseOublier")
);
const Wishlist = lazy(() => import("../../views/Wishlist/Wishlist"));
const Notification = lazy(
  () => import("../../views/Notification/Notification")
);
const ViePrivee = lazy(() => import("../../views/ViePrivee/ViePrivee"));
const PageLostConnexion = lazy(
  () => import("../PageLostConnexion/PageLostConnexion")
);
const Paiement = lazy(() => import("../../views/Paiement/Paiement"));
const PaypalPaiement = lazy(
  () => import("../../components/Payment/CheckoutFormPaypal")
);
const Hashtags = lazy(
  () => import("../HandlerComponentsImport/HandlerHashtags")
);
const ValidationFormCustom = lazy(
  () => import("../HandlerComponentsImport/HandlerValidationCustomForm")
);
export class CustomPage extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      hashtags: [],
      contents: [],
      newUsers: [],
      token: "",
      currentPage: 1,
      pourVous: [],
      contentVideos: [],
      contentPhtos: [],
    };
  }

  componentDidMount() {
    if (this.props.isConnect) {
      this.setState({ token: localStorage.getItem("token") });
    }
    searchUser().then((response) => {
      this.setState({
        newUsers: this.spliceArray(response.data.data.content),
      });
    });
    searchUserContent(null, 5, "VIDEO", this.props.user?.id).then(
      (response) => {
        this.setState({
          contentVideos: response.data.data.content,
        });
      }
    );
    searchUserContent(null, 5, "PHOTO", this.props.user?.id).then(
      (response) => {
        this.setState({
          contentPhotos: response.data.data.content.slice(0, 5),
        });
      }
    );
    getAllHashtags().then((response) => {
      this.setState({ hashtags: response });
    });
    friendSuggestion(this.props.user?.id).then((response) => {
      this.setState({ pourVous: response?.data.data.content });
    });
  }

  spliceArray(x, top) {
    if (top) {
      return x.filter((i, idx) => idx > Math.floor(x.length / 2));
    } else {
      return x.filter((i, idx) => idx < Math.floor(x.length / 2));
    }
  }

  setStateOfParent = () => {
    searchUser().then((response) => {
      this.setState({
        newUsers: this.spliceArray(response.data.data.content),
      });
    });
    friendSuggestion(this.props.user?.id).then((response) => {
      this.setState({ pourVous: response?.data.data.content });
    });
  };

  render() {
    var statusConnexion = window.navigator.onLine;

    let item = localStorage.getItem("pseudo");
    return statusConnexion ? (
			<div
				className="container-fluid h-100 scrollable100">
				<div className="row h-100">
					{/* Left Col */}
					<div
						className="col-lg-3 col-xl-3 d-none d-xl-block"
						style={{ height: '100%' }}>
						<div className="onTheTop k-semibold-13" style={{ width: '318px' }}>
							<p className="k-semibold-20">On the top</p>
							<CustomCard label={'Profile'} data={this.state.newUsers} />
							<CustomCard label={'Videos'} data={this.state.contentVideos} />
							<CustomCard label={'Photos'} data={this.state.contentPhotos} />
						</div>
						<StickyFooter />
					</div>

					{/* Center Col*/}
					<div
						ref={this.myRef}
						className={`col-xl-6 main-content`}
						style={{ height: '100%', padding: 0 }}>
						{/* Child Component */}
						<div
							className="child-component"
							style={{ width: '100%', height: '100%' }}>
							<Suspense fallback={<div></div>}>
								{this.props.match.url === '/' && (
									<Home
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}
								{this.props.match.path === '/details-user/:val' && (
									<DetailsUserScreen
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}
								{this.props.match.url === '/live' && (
									<Live
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}
								{this.props.match.path === '/formSignaler/:val' && (
									<FormSignaler
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}
								{this.props.match.path === '/formBloquer/:val' && (
									<FormBloquer
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}
								{this.props.match.path === '/formBloquerInDiscussion/:val' && (
									<FormBloquerInDiscussion
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}
								{this.props.match.path === '/registration/:val' && (
									<InscriptionScreen props={this.props} />
								)}
								{this.props.match.path === '/login' && (
									<Login props={this.props} />
								)}
								{this.props.match.path === '/motDePasseOublier' && (
									<MotDePasseOublier
										props={this.props}
										setStateOfParent={this.setStateOfParent}
										history={this.props.history}
										pseudo={item}
									/>
								)}
								{this.props.match.path === '/Wishlist' && (
									<Wishlist
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}
								{this.props.match.path === '/notification' && (
									<Notification
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}
								{this.props.match.path === '/ViePrivee' && (
									<ViePrivee
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}
								{this.props.match.path === '/Hashtags/:val' && (
									<Hashtags
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}
								{this.props.match.path === '/Paiement/:val' && (
									<Paiement
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}{' '}
								{this.props.match.path === '/paymentpaypal' && (
									<PaypalPaiement
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}{' '}
								{this.props.match.path === '/Validation' && (
									<ValidationFormCustom
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}{' '}
								{this.props.match.path === '/ValidationPaymentCard' && (
									<ValidationPayment
										props={this.props}
										setStateOfParent={this.setStateOfParent}
									/>
								)}{' '}
							</Suspense>
						</div>
					</div>

					{/* Right Col*/}
					<div
						className="col-lg-3 d-none d-xl-flex flex-column align-items-end"
						style={{ height: '100%' }}>
						<div
							className="d-flex flex-column align-items-end"
							style={{ width: '318px', gap: '10px' }}>
							<CardPourVous
								peoples={this.state?.pourVous}
								token={this.state?.token}
								senderId={this.props.user?.id}
								isConnect={this.props?.isConnect}
								setStateOfParent={this.setStateOfParent}
							/>
							<CardHashtags hashtags={this.state?.hashtags} />
							{/* <CardApplication /> */}
						</div>
					</div>
				</div>
				<Toaster />
			</div>
		) : (
			<PageLostConnexion />
		);
  }
}
const mapStateToProps = (state) => ({
  isConnect: state.compteReducers.isConnected,
  user: state.compteReducers.userConnected,
});
export default connect(mapStateToProps)(CustomPage);
